<template>
  <div class="eh-banner">
    <div class="eh-banner-background"></div>
    <div class="container">
      <div class="eh-header-wrapper pt-4">
        <div class="row mx-0 pt-4">
          <div class="eh-title">{{ title }}</div>
          <div class="pl-2 pt-2">
            <employee-hub-bookmark
                :title="title"
                show-circle
                class="d-inline-block eh-bookmark mt-1"
                blue-bookmark="false"
            ></employee-hub-bookmark>
          </div>
        </div>


        <div class="eh-description">
          <div>Your guide to purchasing goods and services, and working with suppliers</div>
          <a :href="walkThroughModal" @click.prevent="launchWalkThroughModal" class="launch-walk-through-text">Learn how to engage a supplier</a>
        </div>
      </div>

      <!-- search -->
      <div class="search-container mt-4 mb-5 pr-3 pt-2">
        <div class="row">
          <div class="col-12">
            <div class="input-group-prepend search-input-container">
              <span class="input-group-text">
                <img
                  v-if="showSearchSpinner"
                  class="search-loading-spinner"
                  :src="CONSTANTS.SPINNER_URL"
                />
                <img v-else src="@/assets/images/search_icon.svg" />
              </span>
              <div class="input-container">
                <input
                  type="text"
                  v-model="searchTerm"
                  placeholder="Search here"
                  class="form-control"
                />
                <button
                  v-if="searchTerm"
                  class="close close-btn mr-1"
                  @click="clearSearchTerm"
                >
                  <font-awesome-icon :icon="['far', 'times-circle']" size="lg" />
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>


    </div>
    <nav-banner-message v-if="CONSTANTS.NAV_BANNER_MESSAGE.showMessage" />

    <div class="container-fluid px-0 mt-0">
      <div class="eh-nav-wrapper">
        <div class="container px-0">
        <!-- hamburger menu for smaller screens -->
        <button
            class="navbar-toggler toggle-sl-button d-block d-lg-none mx-2"
            type="button"
            data-toggle="collapse"
            data-target="#navbarNav"
            aria-controls="navbarNav"
            aria-expanded="false"
            aria-label="Toggle navigation"
            ref="navbarToggler"
        >
          <img
              src="@/assets/images/hamburger_menu_icon.svg"
              alt="hamburger-dropdown"
          />
        </button>

        <nav class="navbar navbar-tab navbar-expand-lg navbar-light sl-navbar px-0 ml-0 py-0">
          <div class="collapse navbar-collapse" id="navbarNav">
            <ul class="nav nav-tabs">
              <div v-for="(tab, index) in tabs" :key="index" class="responsive-nav-align">
                <li class="nav-item" :class="index === tabs.length - 1 ? null : 'pr-lg-2 pr-0'">
                  <router-link
                      @click.native="onNavItemClicked(tab)"
                      class="nav-link"
                      :class="[activeTab === tab.type ? 'router-link-active' : '']"
                      :to="tab.to"
                  >
                    <div>{{ tab.title }}</div>
                  </router-link>
                </li>
              </div>
            </ul>
          </div>
        </nav>
      </div>
      </div>
      </div>

  </div>
</template>

<script>
import HomePage from '@/components/homepage/HomePage'
import { mapGetters, mapActions, mapMutations } from "vuex";
import CONSTANTS from "@/store/constants"
import NavBannerMessage from "@/components/homepage/NavBannerMessage";

export default {
  name: "nav-banner",
  components: {NavBannerMessage},
  data() {
    return {
      currentComponent:HomePage,
      title: "Supplier Central",
      searchTerm: "",
      tabs: []
    };
  },
  watch: {
    "searchTerm": function(newVal) {
      this.$emit("onSearchTermChanged", newVal)
    }
  },
  computed: {
    ...mapGetters(["isLoading","categoryAccessMethods", "showSearchSpinner","invoiceCategoryAccessMethods"]),
    activeTab() {
      return this.$route.meta.tab
    },
    walkThroughModal(){
      const currentUrl = window.location.href;
      let baseUrl = currentUrl.includes(CONSTANTS.LOCALHOST_URL) ? 'http://'+CONSTANTS.LOCALHOST_URL : CONSTANTS.EH_URL
      return baseUrl +  "/apps/supplier-central" + CONSTANTS.WORKING_WITH_SUPPLIER_ROUTE;
    }
  },
  created: function() {
    this.clearAllFormsData()
  },
  mounted() {
    this.setNavTabs()
  },
  methods: {
    ...mapMutations(["setErrorMessage"]),
    ...mapActions(["clearAllFormsData"]),
    launchWalkThroughModal() {
      this.$hhMixpanel.trackEvent('Supplier central - Learn how to work with suppliers clicked');
      this.$router.push({name: "SCWalkThroughModalContainer",params: {currentRoute: this.$route.meta.tab}})
    },
    onNavItemClicked() {
      this.setErrorMessage('')
      this.clearSearchTerm()
      //The below condition gets triggered when tabs is switched between the dashboard, to effectively toggle between the categories under My Supplier requests tab and Invoices Category Tab and we reset the nav-items state.
      this.categoryAccessMethods.clicked = false
      this.categoryAccessMethods.isAccessedViaDeeplink = true
      this.invoiceCategoryAccessMethods.clicked = false
      this.invoiceCategoryAccessMethods.isAccessedViaDeeplink = true
    },
    setNavTabs() {
      this.$router.options.routes.forEach((route) => {
        if(route && route.children && route.children.length > 0) {
          route.children.forEach((childRoute) => {
            if(childRoute && childRoute.meta && childRoute.meta.navTabName && childRoute.meta.navTabName.length > 0) {
              this.tabs.push({ to: childRoute.path, title: childRoute.meta.navTabName, type: childRoute.name, order: childRoute.meta.navTabOrder })
            }
          })
        }
      })
      this.tabs.sort((a, b) => a.order - b.order)
    },
    launchOneIntakeForm() {
      this.$router.push({ name: "OneIntakeForm" });
    },
    clearSearchTerm() {
      this.searchTerm = ""
      this.$emit('onSearchTermCleared')
    },
  },
};
</script>

<style scoped>
.launch-walk-through-text {
  text-decoration: underline;
  color: #FFFFFF !important;
}


.eh-banner-background {
  width: 100vw !important;
  background-repeat: no-repeat !important;
  background-size: cover !important;
  background-position: 50% !important;
  height: 600px !important;
  min-height: 40px;
  position: absolute;
  z-index: -1;
  background: var(--breadcrumb-color);
}


/* navbar styles */
.navbar-toggler img {
  background-color: #ffffff;
}
.navbar {
  font-family: artifaktElementRegular !important;
  font-size: 16px;
}

@media screen and (min-width: 992px){
  .navbar-tab {
    background-color: #f4f6f8;
  }
}

.eh-nav-wrapper {
  background-color: #f4f6f8;
}

@media screen and (max-width: 992px) {
  .nav-item {
    min-width: 100%;
  }
  .navbar-tab {
    background-color: #f4f6f8;
  }

  .responsive-nav-align {
    min-width: 100%;
  }
}

.nav-tabs {
  border: none;
}
.nav-tabs li a {
  min-width: 100px;
  padding-top: 14px;
  padding-bottom: 14px;
  text-align: center;
  font-size: 16px;
  color: #000;
}
.nav-link {
  border: none;
  border-radius: 0;
  border: 0 !important;
}

.router-link-active {
  font-family: artifaktElementBold !important;
  color: var(--secondary-color) !important;
  background-color: #fff;
  border-bottom-color: transparent!important;
}




/* header styles */
.eh-header-wrapper {
  font-family: artifaktElementBold !important;
  color: #ffffff !important;
}
.eh-title {
  font-size: 38px;
  color: var(--breadcrumb-text)
}
.eh-description {
  font-size: 20px;
  color: var(--breadcrumb-text)
}


/* search styles */
input::placeholder {
  color: #000;
  font-size: 20px;
  font-style: italic;
}

/* Webkit */
[placeholder]:focus::-webkit-input-placeholder { opacity: 0; }
/* Firefox < 19 */
[placeholder]:focus:-moz-placeholder { opacity: 0; }
/* Firefox > 19 */
[placeholder]:focus::-moz-placeholder { opacity: 0; }
/* Internet Explorer 10 */
[placeholder]:focus:-ms-input-placeholder { opacity: 0; }

.search-container {
  height: 40px;
}
.search-container .input-group-text {
  background-color: #ffffff;
  border-top-left-radius: 25px;
  border-bottom-left-radius: 25px;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  cursor: pointer;
  border-color: var(--breadcrumb-text);
  border-right: none !important;
  line-height: 1.5;
  padding-right: 20px;
  padding: 0.375rem 0.77rem;
  white-space: nowrap;
  padding-right: 5px;
  width: 40px;
}
.search-container .input-group-text img {
  fill: #000000 !important;
}
.search-container input {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
  border-top-right-radius: 100px;
  border-bottom-right-radius: 100px;
  border: none;
  font-size: 20px;
}
.search-container .input-container {
  width: 100%;
  max-width: 700px;
}

.search-loading-spinner {
  width: 25px;
  height: 25px;
  z-index: 2;
}

.search-input-container {
  margin-right: 15px;
  height: 50px;
}
.search-input-container .form-control {
  height: 100%;
  border: 1px solid var(--breadcrumb-text);
  border-left: none !important;
}
.search-input-container .form-control:focus {
  box-shadow: none !important;
  border-color: var(--breadcrumb-text) !important;

}

.close-btn {
  transform: translateY(-51px);
  height: 100%;
  outline: none;
  color: #000000;
  padding-right: 15px;
}

.close-btn svg {
  width: 0.65em;
  height: 0.8em;
  color: #000000;
}
</style>
